import React from 'react'
import {Trans} from 'react-i18next'

import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'

import {
  RadioQuestion,
  questionTitleStyles,
} from '@progyny/pages/Consultations/components/questions/types'

interface RadioQuestionRendererProps {
  question: RadioQuestion
  formData: Record<string, string>
  handleInputChange: (questionId: string, value: string) => void
  isSubmitting: boolean
  colors: {primary: string; secondary: string}
}

const RadioQuestionRenderer: React.FC<RadioQuestionRendererProps> = ({
  question,
  formData,
  handleInputChange,
  isSubmitting,
  colors,
}) => {
  const selectedValue = formData[question.id] || ''

  return (
    <FormControl
      component='fieldset'
      fullWidth
      sx={{maxWidth: '640px', margin: '0 auto'}}
    >
      <FormLabel
        component='legend'
        sx={{width: '100%', display: 'block', marginBottom: '38px'}}
      >
        <Typography sx={questionTitleStyles}>
          <Trans>{question.title}</Trans>
        </Typography>
      </FormLabel>
      <RadioGroup
        value={selectedValue}
        onChange={(e) => handleInputChange(question.id, e.target.value)}
        sx={{gap: '12px'}}
      >
        {question.options.map((option) => {
          const isSelected = selectedValue === option.value
          return (
            <Box
              key={option.value}
              sx={{
                border: isSelected
                  ? `2px solid ${colors.primary}`
                  : '2px solid #EAECF0',
                borderRadius: '12px',
                backgroundColor: isSelected ? colors.secondary : 'transparent',
                padding: '20px 16px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                justifyContent: 'center',
                '&:hover': {
                  borderColor: isSubmitting ? undefined : colors.primary,
                },
              }}
              onClick={() => {
                if (!isSubmitting) {
                  handleInputChange(question.id, option.value)
                }
              }}
            >
              <FormControlLabel
                value={option.value}
                control={
                  <Radio disabled={isSubmitting} sx={{display: 'none'}} />
                }
                label={option.label}
                sx={{
                  margin: 0,
                  '& .MuiFormControlLabel-label': {
                    color: isSelected ? colors.primary : 'inherit',
                    fontWeight: isSelected ? 600 : 'inherit',
                    textAlign: 'center',
                  },
                }}
              />
            </Box>
          )
        })}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioQuestionRenderer
